import {
  Box,
  Grid,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { grey } from "@mui/material/colors";
import NoData from "../../NoData";

const priceTableColumnSx = {
  fontSize: 18,
};

const GroupCell = ({
  item,
  name,
  data,
  dataKey,
  align,
  render,
  pagination,
  formatter,
  sx,
  ...properties
}) => {
  const subData = data.filter((row) => row[name] === item[name]);
  const firstGroup = subData[0];

  const format = formatter ? formatter(item[name]) : item[name];
  const nameFormat =
    item?.[name] !== undefined && item?.[name] !== null ? format : "";
  return dataKey && item[dataKey] === firstGroup[dataKey] ? (
    <TableCell align={align} rowSpan={subData.length} sx={{ ...sx }}>
      {name === "no" ? (
        <span>
          {/* TODO: modify display number if group  */}
          {render
            ? render(item, renderIndex(item?.no, pagination))
            : renderIndex(item?.no, pagination)}
        </span>
      ) : (
        <span>{render ? render(item) : nameFormat}</span>
      )}
    </TableCell>
  ) : null;
};

const TableCellCustomize = ({
  name,
  item,
  data,
  render,
  onClick,
  isGroup,
  dataKey,
  alternateColor,
  formatter,
  pagination,
  groupColumn,
  align,
  index,
  renderComponent,
  sx,
  ...properties
}) => {
  const listGroup = [...new Set(data.map((item) => item[groupColumn]))];
  const isAlternateColor = () => {
    if (groupColumn) {
      return listGroup.indexOf(item[groupColumn]) > 0 &&
        listGroup.indexOf(item[groupColumn]) % 2 > 0
        ? grey[100]
        : "none";
    }
    return data.indexOf(item) > 0 && data.indexOf(item) % 2 > 0
      ? grey[100]
      : "none";
  };
  return isGroup ? (
    <GroupCell
      render={render}
      item={item}
      data={data}
      align={align}
      name={name}
      dataKey={dataKey}
      pagination={pagination}
      formatter={formatter}
      onClick={onClick ? () => onClick(item) : () => { }}
      sx={{
        fontSize: 18,
        backgroundColor: alternateColor ? isAlternateColor : "none",
        ...sx?.rowCell,
      }}
      {...properties}
    />
  ) : (
    <TableCell
      align={align}
      onClick={onClick ? () => onClick(item) : () => { }}
      sx={{
        fontSize: 18,
        backgroundColor: alternateColor ? isAlternateColor : "none",
        ...sx?.rowCell,
      }}
    // {...properties}
    >
      {name === "no"
        ? renderIndex(index + 1, pagination)
        : renderComponent(render, item, name, formatter)}
    </TableCell>
  );
};

const renderIndex = (index, pagination = null) =>
  pagination ? pagination.page * pagination.pageSize + index : index;

export default function NormalTable({
  columns,
  data,
  emptyDescription,
  hover,
  sx,
  pagination,
  paginationTop,
  ...props
}) {
  const [paginationInput, setPaginationInput] = useState(
    pagination ? pagination : {}
  );
  const renderComponent = (render, item, name, formatter) => {
    const format = formatter ? formatter(item[name]) : item[name];
    const nameFormat =
      item?.[name] !== undefined && item?.[name] !== null ? format : "";
    return render ? render(item) : nameFormat;
  };

  useEffect(() => {
    setPaginationInput({ ...pagination });
  }, [pagination]);

  const handleChangePageProps = (e) => {
    pagination.handleChangePageProps(e);
  };
  
  return (
    
    <Grid container spacing={2} marginTop={2} marginBottom={2}>
      <Grid item xs={12}>
        {data.length && pagination && paginationTop ? (
          <Grid container marginTop={2} marginBottom={2}>
            <Grid item xs={12} sx={{ textAlign: "center" }}>

              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
             
                <div style={{ margin: 'auto' }}>
                  <Pagination
                    count={paginationInput.totalPage}
                    value={paginationInput.page}
                    variant="outlined"
                    shape="rounded"
                    showFirstButton
                    showLastButton
                    page={paginationInput.page + 1}
                    onChange={(e, p) => handleChangePageProps(p - 1)}
                    sx={{ display: 'inline-block' }}
                    id="paging"
                  />
                </div>
                
              </div>

            </Grid>
          </Grid>
        ) : null}
        <TableContainer component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow sx={{ ...sx?.header }}>
                {columns.map((col) => (
                  <TableCell
                    key={col.key}
                    align={col.align}
                    sx={{
                      ...priceTableColumnSx,
                      backgroundColor: grey[100],
                      whiteSpace: "pre-line",
                      fontSize: 18,
                      ...col?.cellProps,
                      ...col?.cellProps?.headerCell,
                      ...sx?.header,
                    }}
                  >
                    {typeof col.label === "function" ? col.label() : col.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {data && data?.length > 0 ? (
              <TableBody
                sx={{
                  ".MuiTableCell-root": {
                    py: 0,
                    px: 1.5,
                    height: "54px",
                    lineHeight: "22px",
                  },
                  position: "relative",
                  zIndex: 0,
                }}
              >
                {data.map((item, index) => (
                  <TableRow
                    key={`${item?.key}`}
                    sx={{
                      ":hover": hover && {
                        bgcolor: grey[100],
                        cursor: "pointer",
                      },
                      ...sx?.row,
                    }}
                  >
                    {columns.map(
                      ({
                        key,
                        render,
                        onClick,
                        isGroup,
                        dataKey,
                        formatter,
                        align,
                        ...properties
                      }) => (
                        <TableCellCustomize
                          key={`${key}`}
                          name={key}
                          item={item}
                          index={index}
                          isGroup={isGroup}
                          data={data}
                          render={render}
                          onClick={onClick}
                          dataKey={dataKey}
                          alternateColor={!hover}
                          groupColumn={
                            columns.filter((i) => i.isGroup)[0]?.key || ""
                          }
                          align={align}
                          pagination={pagination}
                          formatter={formatter}
                          renderComponent={renderComponent}
                          sx={{
                            ...properties?.cellProps,
                            rowCell: {...(properties?.rowCellPropsByItem && properties.rowCellPropsByItem(item))}
                          }}
                          {...properties}
                        />
                      )
                    )}
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody sx={{ display: "contents" }}>
                <TableRow
                  sx={{
                    height: 200,
                    width: "100%",
                    position: "relative",
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%,-50%)",
                    }}
                    component="td"
                  >
                    <NoData description={emptyDescription} />
                  </Box>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
        {data.length && pagination ? (
          <Grid container marginTop={2} marginBottom={2}>
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Pagination
                count={paginationInput.totalPage}
                value={paginationInput.page}
                variant="outlined"
                shape="rounded"
                showFirstButton
                showLastButton
                page={paginationInput.page + 1}
                onChange={(e, p) => handleChangePageProps(p - 1)}
                sx={{ display: "inline-block" }}
                id="paging"
              />
            </Grid>
          </Grid>
        ) : null}
      </Grid>
    </Grid>

  );
}
